function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useContext, useState } from 'react';
import Spacer from "../../ui/spacer/Spacer";
import FeatherIcon from "../../ui/feather-icon/FeatherIcon";
import { FormContext } from 'noood/contexts/contexts';
import { form_validator } from "../FormFieldValidator";
export default function TextfieldCollection(props) {
  var _form_$formObj, _form_$formObj2;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    new_val = _useState2[0],
    set_new_val = _useState2[1];
  var form_ = useContext(FormContext);
  var __collect = function __collect(vals) {
    form_.__collect(props.name, vals, form_validator.validate(props.validations, vals));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, (form_ === null || form_ === void 0 || (_form_$formObj = form_.formObj) === null || _form_$formObj === void 0 || (_form_$formObj = _form_$formObj[props.name]) === null || _form_$formObj === void 0 ? void 0 : _form_$formObj.length) > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "ui-textfield-collection"
  }, form_ === null || form_ === void 0 || (_form_$formObj2 = form_.formObj) === null || _form_$formObj2 === void 0 || (_form_$formObj2 = _form_$formObj2[props.name]) === null || _form_$formObj2 === void 0 ? void 0 : _form_$formObj2.map(function (val, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      style: {
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch",
        justifyContent: "flex-end"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement("input", {
      style: {
        padding: "4px 8px",
        fontSize: "14px"
      },
      onChange: function onChange(e) {
        var vals = _toConsumableArray(form_.formObj[props.name]);
        vals[idx] = e.target.value;
        __collect(vals);
      },
      value: val
    })), /*#__PURE__*/React.createElement("div", {
      className: "ui-textfield-collection-del"
    }, /*#__PURE__*/React.createElement(FeatherIcon, {
      onClick: function onClick() {
        var vals = _toConsumableArray(form_.formObj[props.name]);
        vals.splice(idx, 1);
        __collect(vals);
      },
      icon: "x"
    })));
  })) : null, /*#__PURE__*/React.createElement(Spacer, {
    mtop: 9
  }), /*#__PURE__*/React.createElement("input", {
    placeholder: "Add an item...",
    style: {
      fontSize: "14px",
      borderRadius: "var(--roundness)",
      padding: "2px 5px"
    },
    value: new_val,
    onChange: function onChange(event) {
      set_new_val(event.target.value);
    },
    onKeyDown: function onKeyDown(event) {
      if (event.code === "Enter") {
        var _event$target$value, _form_$formObj$props$, _form_$formObj3;
        event.preventDefault();
        var v = (_event$target$value = event.target.value) === null || _event$target$value === void 0 ? void 0 : _event$target$value.trim();
        var values = (_form_$formObj$props$ = form_ === null || form_ === void 0 || (_form_$formObj3 = form_.formObj) === null || _form_$formObj3 === void 0 ? void 0 : _form_$formObj3[props.name]) !== null && _form_$formObj$props$ !== void 0 ? _form_$formObj$props$ : [];
        set_new_val('');
        form_.__collect(props.name, [].concat(_toConsumableArray(values), [v]), form_validator.validate(props.validations, values));
      }
    }
  }));
}